const companyTypeOptions = [
  { label: 'Private', value: 0 },
  { label: 'Sole Trader', value: 1 },
  { label: 'Close Corporation', value: 2 },
  { label: 'Public', value: 3 },
];

const industryOptions = [
  { label: 'Accounting / Bookkeeping / Tax Preparation', value: 0 },
  { label: 'Advertising / Design / Media Agencies', value: 1 },
  { label: 'Amusement / Recreational Services', value: 2 },
  { label: 'Auto Sales and/or Repair', value: 3 },
  { label: 'Beauty Salons / Barbers / Hairdresser / Spas', value: 4 },
  { label: 'Business Services', value: 5 },
  { label: 'Catering / Events hire / Event planning', value: 6 },
  { label: 'Child Care', value: 7 },
  { label: 'Construction', value: 8 },
  { label: 'Dentist / Orthodontist / Dental Lab', value: 9 },
  { label: 'Educational Services', value: 10 },
  { label: 'Equipment Sales / Rentals', value: 11 },
  { label: 'Freight / Transportation / Logistics', value: 12 },
  {
    label: 'Health And Fitness / Wellness / Homeopath / Dieticians',
    value: 13,
  },
  { label: 'Hotels / Lodges / BnBs', value: 14 },
  { label: 'Housekeeping / Cleaning Services', value: 15 },
  { label: 'Insurance Agent / Broker / Solicitor', value: 16 },
  { label: 'Interior Design and/or Decorating', value: 17 },
  { label: 'IT And Software Services / Computer Sales', value: 18 },
  { label: 'Landscape / Garden Services', value: 19 },
  { label: 'Laundry / Dry Cleaning Services', value: 20 },
  { label: 'Manufacturer and/or Distributor', value: 21 },
  { label: 'Optometrist', value: 22 },
  { label: 'Other', value: 23 },
  { label: 'Painting / Handyman Services / Home Repair', value: 24 },
  { label: 'Physicians', value: 25 },
  { label: 'Restaurant / Bars', value: 26 },
  { label: 'Retail', value: 27 },
  { label: 'Ecommerce', value: 28 },
  { label: 'Law / Legal Services', value: 29 },
].sort((a: any, b: any) => (a.label > b.label ? 1 : -1));

const beeStatusOptions = [
  { label: 'None', value: -1 },
  { label: 'Level 1', value: 0 },
  { label: 'Level 2', value: 1 },
  { label: 'Level 3', value: 2 },
  { label: 'Level 4', value: 3 },
  { label: 'Level 5', value: 4 },
  { label: 'Level 6', value: 5 },
  { label: 'Level 7', value: 6 },
  { label: 'Level 8', value: 7 },
];

const yearsOperationalOptions = [
  { label: '0 - 1 years', value: '0 - 1 years' },
  { label: '1 - 2 years', value: '1 - 2 years' },
  { label: '2 - 5 years', value: '2 - 5 years' },
  { label: '5 - 10 years', value: '5 - 10 years' },
  { label: '10+ years', value: '10+ years' },
];

const turnoverOptions = [
  { label: 'R0 - R500k', value: 'R0 - R500k' },
  { label: 'R500k - R1m', value: 'R500k - R1m' },
  { label: 'R1m - R2m', value: 'R1m - R2m' },
  { label: 'R2m - R5m', value: 'R2m - R5m' },
  { label: 'R5m - R10m', value: 'R5m - R10m' },
  { label: 'R10m - R20m', value: 'R10m-R20m' },
  { label: 'R20m+', value: 'R20m+' },
];

const employeePositionOptions = [
  { label: 'Director and Major Shareholder (>25%)', value: 0 },
  { label: 'Director', value: 1 },
  { label: 'Major Shareholder(>25%)', value: 2 },
  { label: 'None of the above', value: 4 },
];

export const yearsOperationalEnumMap: { [key: number]: string } = [
  '0 - 1 years',
  '1 - 2 years',
  '2 - 5 years',
  '5 - 10 years',
  '10+ years',
];

export {
  companyTypeOptions,
  industryOptions,
  beeStatusOptions,
  yearsOperationalOptions,
  turnoverOptions,
  employeePositionOptions,
};
